(() => {
  const namespace = '__landingStorytelling';

  if (window[namespace]) {
    window[namespace].init(document);
    return;
  }

  const sectionSelector = '[data-landing-storytelling]';
  const itemSelector = '[data-storytelling-item]';
  const observers = new WeakMap();

  const getSections = (root) => {
    const sections = [];

    if (root instanceof Element && root.matches(sectionSelector)) {
      sections.push(root);
    }

    if (root.querySelectorAll) {
      sections.push(...root.querySelectorAll(sectionSelector));
    }

    return sections;
  };

  const initSection = (section) => {
    if (observers.has(section)) return;

    const items = [...section.querySelectorAll(itemSelector)];
    if (!items.length) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      observers.set(section, { disconnect() {} });
      return;
    }

    section.classList.add('landing-storytelling--animation-enabled');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio >= 0.18) {
            entry.target.classList.add('is-visible');
          } else if (!entry.isIntersecting) {
            entry.target.classList.remove('is-visible');
          }
        });
      },
      {
        root: null,
        rootMargin: '-6% 0px -6% 0px',
        threshold: [0, 0.18],
      },
    );

    items.forEach((item) => observer.observe(item));
    observers.set(section, observer);
  };

  const init = (root = document) => {
    getSections(root).forEach(initSection);
  };

  const destroy = (root) => {
    getSections(root).forEach((section) => {
      const observer = observers.get(section);
      if (!observer) return;

      observer.disconnect();
      observers.delete(section);
    });
  };

  window[namespace] = { init, destroy };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
})();
